import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import {
  formatPosition,
  formatDistance,
  formatHours,
  formatDate,
  formatSpeed,
  formatVolume,
  formatDurationTime,
} from "./common/formatter";

import t from "./common/localization";
import EditItemView from "./EditItemView";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  makeStyles,
  Typography,
  FormControlLabel,
  Checkbox,
  Paper,
} from "@material-ui/core";
import LinkField from "./form/LinkFieldAutoComplete";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import EditAttributesView from "./attributes/EditAttributesView";
import deviceAttributes from "./attributes/deviceAttributes";
import SelectField from "./form/SelectField";
import { deviceCategories } from "./common/deviceCategories";
import { prefixString } from "./common/stringUtils";
import Grid from "@material-ui/core/Grid";
import Styles from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import { useDispatch, useSelector } from "react-redux";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
  DatePicker,
  DateTimePicker,
} from "@material-ui/pickers";
import moment from "moment";
import Chip from "@material-ui/core/Chip";
import AccessTimeIcon from "@material-ui/icons/AccessTime";

const useStyles = makeStyles(() => ({
  details: {
    flexDirection: "flex",
  },
  textField: {
    margin: "4px",
    width: "85%",
  },
  textField1: {
    textTransform: "uppercase",
    margin: "4px",
    width: "85%",
  },
  input: {
    textAlign: "center",
    disableUnderline: "true",
  },
  selectField: {
    width: "85%",
  },
  selectField1: {
    width: "85%",
    '&[data-focus="true"]': {
      backgroundColor: "#b3aeae",
      borderColor: "transparent",
      color: "black",
    },
    // Selected
    '&[aria-selected="true"]': {
      backgroundColor: "#361DDB",
      borderColor: "transparent",
      color: "white",
    },
  },
  root: {
    padding: "10px",
    margin: "10px",
    marginLeft: "60px",
  },
}));

const DevicePage = () => {
  const classes = useStyles();
  const operatingUser = useSelector((state) => state.session.user);
  const adminEnabled = operatingUser.administrator;
  const prepaidUser = operatingUser.prepaid;

  // const [selectedDate, setSelectedDate] = React.useState(null);
  const defaultDateTime = new Date(
    new Date().setFullYear(new Date().getFullYear() + 1)
  );
  const [item, setItem] = useState({ expirationTime: defaultDateTime });
  const expirationTime = item && item.expirationTime;
  const preExpiry = item && item.attributes && item.attributes.preExpiry;

  const handleDateChange = (date) => {
    if (item.expirationTime) {
      const seconds = moment(item.expirationTime).seconds();
      const realDate = moment(date).set("seconds", seconds);
      setItem({ ...item, expirationTime: realDate });
    } else {
      setItem({ ...item, expirationTime: date });
    }

    // setItem({ ...item, contact: date });
  };

  useEffect(() => {
    if (item && !expirationTime) {
      setItem({ ...item, expirationTime: defaultDateTime });
    }
  }, [expirationTime]);

  const handleExpiryDateChange = (date) => {
    if (item.attributes.preExpiry) {
      const seconds = moment(item.attributes.preExpiry).seconds();
      const realDate = moment(date).set("seconds", seconds);
      setItem({
        ...item,
        attributes: { ...item.attributes, preExpiry: realDate },
      });
    } else {
      setItem({ ...item, attributes: { ...item.attributes, preExpiry: date } });
    }
  };

  useEffect(() => {
    if (item && item.attributes && !item.attributes.preExpiry) {
      setItem({ ...item.attributes, preExpiry: defaultDateTime });
    }
  }, [preExpiry]);

  return (
    <EditItemView
      endpoint="devices"
      operatingUser={operatingUser}
      item={item}
      setItem={setItem}
    >
      {item && (
        <>
          <div className={classes.root}>
            <Grid container spacing={3}>
              <Grid item xs={8}>
                <Paper elevation={3}>
                  <Accordion defaultExpanded>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography variant="subtitle1">
                        {t("sharedDeviceDetails")}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.details}>
                      <Grid container spacing={3}>
                        <Grid item xs={6}>
                          <TextField
                            required={true}
                            className={classes.textField}
                            inputProps={{
                              style: { textTransform: "uppercase" },
                            }}
                            InputProps={{ disableUnderline: true }}
                            margin="normal"
                            value={item.name || ""}
                            onChange={(event) =>
                              setItem({ ...item, name: event.target.value })
                            }
                            label={t("settingsVehicleNumber")}
                            variant="standard"
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            required={true}
                            className={classes.textField}
                            InputProps={{ disableUnderline: true }}
                            margin="normal"
                            value={item.uniqueId || ""}
                            onChange={(event) =>
                              setItem({ ...item, uniqueId: event.target.value })
                            }
                            label={t("deviceIdentifier")}
                            variant="standard"
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            required={true}
                            type="number"
                            className={classes.textField}
                            InputProps={{ disableUnderline: true }}
                            margin="normal"
                            value={item.phone || ""}
                            onChange={(event) =>
                              setItem({ ...item, phone: event.target.value })
                            }
                            label={t("settingsDeviceSimNumber")}
                            variant="standard"
                          />
                        </Grid>

                        <Grid item xs={6}>
                          <FormControl className={classes.selectField}>
                            <SelectField
                              className={classes.selectField1}
                              value={item.model || "Common"}
                              emptyValue={null}
                              onChange={(e) =>
                                setItem({ ...item, model: e.target.value })
                              }
                              keyGetter={(it) => it.name}
                              endpoint="/api/server/supportedPorts"
                              label={t("deviceModel")}
                              variant="standard"
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                          <FormControl className={classes.selectField}>
                            <SelectField
                              value={item.groupId || 0}
                              onChange={(event) =>
                                setItem({
                                  ...item,
                                  groupId: Number(event.target.value),
                                })
                              }
                              endpoint="/api/groups"
                              label={t("groupParent")}
                              variant="standard"
                            />
                          </FormControl>
                        </Grid>

                        <Grid item xs={6}>
                          <TextField
                            className={classes.textField}
                            type="number"
                            InputProps={{ disableUnderline: true }}
                            margin="normal"
                            value={item.contact || ""}
                            onChange={(event) =>
                              setItem({ ...item, contact: event.target.value })
                            }
                            label={t("deviceContact")}
                            variant="standard"
                          />
                        </Grid>

                        <Grid item xs={6}>
                          <FormControl className={classes.selectField}>
                            <SelectField
                              value={item.category || "car"}
                              emptyValue={null}
                              onChange={(event) =>
                                setItem({
                                  ...item,
                                  category: event.target.value,
                                })
                              }
                              data={deviceCategories.map((category) => ({
                                id: category,
                                name: t(
                                  `category${category.replace(/^\w/, (c) =>
                                    c.toUpperCase()
                                  )}`
                                ),
                              }))}
                              label={t("deviceCategory")}
                              variant="standard"
                            />
                          </FormControl>
                        </Grid>
                        {(adminEnabled || !prepaidUser) && (
                          <Grid item xs={6}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <DatePicker
                                disableToolbar
                                variant="standard"
                                InputProps={{ disableUnderline: true }}
                                format="dd/MM/yyyy"
                                id="date-picker-inline"
                                label="Device Expiry Date"
                                value={item.expirationTime}
                                // onChange={(event) =>
                                //   setItem({ ...item, contact: event.target.value })
                                // }
                                onChange={handleDateChange}
                                KeyboardButtonProps={{
                                  "aria-label": "change date",
                                }}
                              />
                            </MuiPickersUtilsProvider>

                            {/* <TextField
   className={classes.textField}
  InputProps={{ disableUnderline: true }}
  margin="normal"
   value={item.contact || ""}
  onChange={(event) =>
  setItem({ ...item, contact: event.target.value })
  }
   label="Device account Expiry date"
  variant="standard"
  /> */}
                          </Grid>
                        )}

                        {item.prepaid && operatingUser.attributes.preExpiryAccess && item.id && (
                          <>
                            <Grid item xs={6}>
                              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <DatePicker
                                  disableToolbar
                                  variant="standard"
                                  InputProps={{ disableUnderline: true }}
                                  format="dd/MM/yyyy"
                                  id="date-picker-inline"
                                  label="Device Pre Expiry Date"
                                  value={item.attributes.preExpiry || null}
                                  onChange={handleExpiryDateChange}
                                  KeyboardButtonProps={{
                                    "aria-label": "change date",
                                  }}
                                />
                              </MuiPickersUtilsProvider>

                              {/* <TextField
   className={classes.textField}
  InputProps={{ disableUnderline: true }}
  margin="normal"
   value={item.contact || ""}
  onChange={(event) =>
  setItem({ ...item, contact: event.target.value })
  }
   label="Device account Expiry date"
  variant="standard"
  /> */}
                            </Grid>

                            <Grid item xs={6}>
                              <Chip
                                label={formatDate(
                                  item.expirationTime,
                                  "MMM DD YYYY, hh:mm A"
                                )}
                                icon={<AccessTimeIcon />}
                                size="small"
                                color="secondary"
                                style={{
                                  backgroundColor: "#EFEBFC",
                                  color: "#623DE6",
                                  borderRadius: 3,
                                  margin: "5px",
                                }}
                              />
                            </Grid>
                          </>
                        )}
                        {adminEnabled && (
                          <Grid item xs={6}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={item.disabled}
                                  onChange={(event) =>
                                    setItem({
                                      ...item,
                                      disabled: event.target.checked,
                                    })
                                  }
                                />
                              }
                              label={t("sharedDisabled")}
                            />
                          </Grid>
                        )}
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                </Paper>

                {item.id && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Paper elevation={3}>
                        <Accordion>
                          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography variant="subtitle1">
                              {t("sharedConnections")}
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails className={classes.details}>
                            <Grid container spacing={3}>
                              <Grid item xs={6}>
                                <FormControl className={classes.selectField}>
                                  <LinkField
                                    endpointAll="/api/geofences"
                                    endpointLinked={
                                      "/api/geofences?deviceId=" + item.id
                                    }
                                    baseId={item.id}
                                    keyBase="deviceId"
                                    keyLink="geofenceId"
                                    label={t("sharedGeofences")}
                                    variant="standard"
                                  />
                                </FormControl>
                              </Grid>

                              <Grid item xs={6}>
                                <FormControl className={classes.selectField}>
                                  <LinkField
                                    endpointAll="/api/notifications"
                                    endpointLinked={
                                      "/api/notifications?deviceId=" + item.id
                                    }
                                    baseId={item.id}
                                    keyBase="deviceId"
                                    keyLink="notificationId"
                                    titleGetter={(it) =>
                                      t(prefixString("event", it.type))
                                    }
                                    label={t("sharedNotifications")}
                                    variant="standard"
                                  />
                                </FormControl>
                              </Grid>
                            </Grid>
                          </AccordionDetails>
                        </Accordion>
                      </Paper>
                    </Grid>
                  </Grid>
                )}
              </Grid>

              <Grid item xs={4}>
                <Paper elevation={3}>
                  <Accordion defaultExpanded>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography variant="subtitle1">
                        {t("sharedAttributes")}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.details}>
                      <EditAttributesView
                        attributes={item.attributes}
                        setAttributes={(attributes) =>
                          setItem({ ...item, attributes })
                        }
                        definitions={deviceAttributes}
                      />
                    </AccordionDetails>
                  </Accordion>
                </Paper>
              </Grid>
            </Grid>
          </div>
        </>
      )}
    </EditItemView>
  );
};

export default DevicePage;
